import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('MAILCHIMP_SYNC_LOG');
